import { render } from "./InternalMenuItem.vue?vue&type=template&id=f633fe4c&scoped=true"
import script from "./InternalMenuItem.vue?vue&type=script&lang=js"
export * from "./InternalMenuItem.vue?vue&type=script&lang=js"

import "./InternalMenuItem.vue?vue&type=style&index=0&id=f633fe4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f633fe4c"]])

export default __exports__